module.exports = __webpack_public_path__ + "img/Icon-tourn-panonav.fb94763e.svg";